<accredible-two-columns-layout
  *transloco="let t; read: 'email-verification'"
  backgroundImage="'/assets/images/two-columns-layout-component/layout-purple.png'"
  [singleColumn]="true">
  <accredible-top-border-card>
    <div class="header">
      <img src="/assets/images/accredible-new-logo.svg" alt="" />
      <div class="text">
        <h1
          class="mat-h2"
          [innerHTML]="status === 'succeeded' ? t('success.title') : t('failure.title')"></h1>
      </div>
    </div>

    <acs-email-sent
      [status]="status"
      [subtitle]="status === 'succeeded' ? t('success.message') : t('failure.message')"
      [routerLinkAction]="status === 'succeeded' ? routerLinkAction : null">
    </acs-email-sent>

    @if (status !== 'succeeded') {
      <accredible-button-loading
        data-cy="btn-email-verification-action"
        [btnText]="routerLinkAction.text | async"
        [size]="'large'"
        (click)="onActionButtonClicked()">
      </accredible-button-loading>

      <accredible-divider />

      <div class="footer">
        <div>
          {{ t('footer.title') }}
          <a [routerLink]="'/login'">
            {{ t('sign_in') }}
          </a>
        </div>
      </div>
    }
  </accredible-top-border-card>
</accredible-two-columns-layout>
